import Repository from "../../Apicall/Repository";

const ADD_LANDINGPAGE = "add";
const GET_LANDINGPAGE = "getAll";
const UPDATE_LANDINGPAGE = "updateLandingPage";
const DELETE_LANDINGPAGE = "deleteLanding";
const UPDATE_FULLURL = "updateUrl";
const GET_SINGLE = "getSingle";
const UPDATE_OPENS = "updateOpens";
const UPDATE_CLIENT_CLICK = "updateClientClick";

export default {
  getAllLandingPage(payload) {
    return Repository.post(transformRoute(GET_LANDINGPAGE), payload);
  },
  addLandingPage(payload) {
    return Repository.post(transformRoute(ADD_LANDINGPAGE), payload);
  },
  editLandingPage(payload) {
    return Repository.post(transformRoute(UPDATE_LANDINGPAGE), payload);
  },
  deleteLandingPage(payload) {
    return Repository.post(transformRoute(DELETE_LANDINGPAGE), payload);
  },
  updateFullURL(payload) {
    return Repository.post(transformRoute(UPDATE_FULLURL), payload);
  },
  getSingle(payload) {
    return Repository.post(transformRoute(GET_SINGLE), payload);
  },
  updateOpens(payload) {
    return Repository.post(transformRoute(UPDATE_OPENS), payload);
  },
  updateClientClick(payload) {
    return Repository.post(transformRoute(UPDATE_CLIENT_CLICK), payload);
  },
};

const transformRoute = (route) => {
  return `/marcom/landingpage/${route}`;
};
